// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"8cb669db","738":"8cb669db","923":"8cb669db","971":"8cb669db"}[chunkId] + ".chunk.css";
};